import React, { useEffect } from 'react'
import { H1, LayoutBand, MarginBox, Separator, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useHistory } from '@fs/zion-router'
import { TogetherAppAndroidButton } from '@fs/zion-mobile-app-buttons'
import getIsTWAMode from '../../helpers/appMode_helper'

export default function UpdateTWANotice() {
  // This page component is for handling the logout redirect and restarting the TWA
  const history = useHistory()
  const { t } = useTranslation()
  const isTWAMode = getIsTWAMode()
  useEffect(() => {
    if (!isTWAMode) {
      // If someone stumbles upon this path, send them to the home page.
      history.push('/')
    }
  }, [history, isTWAMode])
  return (
    <LayoutBand>
      <MarginBox marginY="lg">
        <H1 size="H5" centered>
          {t('update-twa-warning', 'You must upgrade to the latest version of Together By FamilySearch*')}
        </H1>
        <Separator />
        <Row alignX="center">
          <TogetherAppAndroidButton />
        </Row>
      </MarginBox>
    </LayoutBand>
  )
}
